import React, { Component } from 'react';
import { Breadcrumb, Select, Button, message, Divider } from 'antd';

import { ACTION_STATUS } from '../../../../utils/ActionStatus';
import { localStorageClient } from '../../../../utils/localStorageClient';
import LicenseGrid from './LicenseGrid';
import AddOrEditLicenseModalDialog from './AddOrEditLicenseModalDialog';
import DelLicenseModalDialog from './DelLicenseModalDialog';
import OperationRecordDialog from '../../common/historyUpload/operationRcd/components/OperationRecordDialog';
import './LicenseDashboard.css';

const Option = Select.Option;
const regulatorOptions = ['MAS', 'SFC', 'SEBI', 'KFB'];

class LicenseDashboard extends Component {
  componentDidMount() {
    this.refreshBtnOnClicked();
  }

  componentDidUpdate() {
    const {
      loadLicenseInfoActionStatus,
      loadLicenseInfoResp,
    } = this.props;

    if (loadLicenseInfoActionStatus === ACTION_STATUS.SUCCESS) {
      this.props.initLoadLicenseInfoActionStatus();
    }
    if (loadLicenseInfoActionStatus === ACTION_STATUS.ERROR) {
      let err = 'Load License Info failed';
      if (loadLicenseInfoResp && loadLicenseInfoResp.respMessage) {
        err = loadLicenseInfoResp.respMessage;
      }
      message.error(err);
      this.props.initLoadLicenseInfoActionStatus();
    }
  }

  onInputChange = ({ name, value }) => {
    this.props.onLicenseQueryInputChange({ name, value });
  };

  refreshBtnOnClicked = () => {
    const { regulator, showAll } = this.props.licenseQueryFields;
    this.props.loadLicenseInfo({
      employee: localStorageClient.getUserName(),
      regulator,
      showAll,
    });
  };

  toggleShowAll = () => {
    const { regulator, showAll } = this.props.licenseQueryFields;
    this.props.onLicenseQueryInputChange({ name: 'showAll', value: !showAll });
    this.props.loadLicenseInfo({
      employee: localStorageClient.getUserName(),
      regulator,
      showAll: !showAll,
    });
  };

  addOrEditBtnOnClicked = mode => {
    if (mode === 'ADD') {
      this.props.openAddOrEditLicenseModal(mode, null);
      return;
    }
    const { selectedLicenseInfoArray } = this.props;
    if (selectedLicenseInfoArray.length !== 1) {
      message.warning('Please choose one and only one License record');
      return;
    }
    this.props.openAddOrEditLicenseModal(mode, selectedLicenseInfoArray[0]);
  };

  delBtnOnClicked = () => {
    const { selectedLicenseInfoArray } = this.props;
    if (selectedLicenseInfoArray.length !== 1) {
      message.warning('Please choose one and only one License record');
      return;
    }
    this.props.openDelLicenseModal(selectedLicenseInfoArray[0]);
  };

  operationRcdBtnOnClicked = () => {
    const { selectedLicenseInfoArray, licenseOperationRecordUrl, loadLicenseInfoResp } = this.props;
    const queryFields = {
      module: 'License',
      queryUrl: licenseOperationRecordUrl,
    };
    if (selectedLicenseInfoArray && selectedLicenseInfoArray.length > 0) {
      queryFields.dataId = selectedLicenseInfoArray.map(item => item.id).join(',');
    } else {
      const allRows = loadLicenseInfoResp && Array.isArray(loadLicenseInfoResp.data)
        ? loadLicenseInfoResp.data
        : [];
      if (allRows.length > 0) {
        queryFields.dataId = allRows.map(item => item.id).join(',');
      } else {
        queryFields.dataId = '-1';
      }
    }
    this.props.doOperationRecordAction({
      action: 'OPEN_AND_QUERY',
      queryFields,
      customColumns: ['operator', 'operateTime', 'dataId', 'operateType', 'comments', 'before', 'after'],
    });
  };

  render() {
    const {
      licenseQueryFields,
      loadLicenseInfoActionStatus,
    } = this.props;
    const { regulator, showAll } = licenseQueryFields;
    const refreshBtnIsLoading = loadLicenseInfoActionStatus === ACTION_STATUS.LOGINING;

    return (
      <div className="LicenseWrapper">
        <div className="breadcrumbWrapper">
          <Breadcrumb>
            <Breadcrumb.Item>Licensing</Breadcrumb.Item>
            <Breadcrumb.Item>License</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="LicenseOperationBar">
          <Select
            allowClear
            size="small"
            value={!regulator ? undefined : regulator}
            style={{ width: 160, marginLeft: 10 }}
            placeholder="Regulator"
            onChange={value => this.onInputChange({ name: 'regulator', value })}
          >
            {regulatorOptions.map(item => (
              <Option key={item} value={item}>{item}</Option>
            ))}
          </Select>
          <Button
            onClick={this.refreshBtnOnClicked}
            loading={refreshBtnIsLoading}
            size="small"
            style={{ marginLeft: 10 }}
            type="primary"
            icon="search"
          />

          <Divider type="vertical" />

          <Button
            onClick={this.toggleShowAll}
            size="small"
            style={{ marginLeft: 0 }}
            type={showAll ? 'primary' : 'default'}
          >
            Show All
          </Button>

          <Divider type="vertical" />

          <Button
            onClick={() => this.addOrEditBtnOnClicked('ADD')}
            size="small"
            style={{ marginLeft: 0 }}
            className="positive-button"
          >
            Add
          </Button>
          <Button
            onClick={() => this.addOrEditBtnOnClicked('COPY')}
            size="small"
            style={{ marginLeft: 10 }}
            className="positive-button"
          >
            Copy
          </Button>
          <Button
            onClick={() => this.addOrEditBtnOnClicked('EDIT')}
            size="small"
            style={{ marginLeft: 10 }}
            type="primary"
          >
            Edit
          </Button>
          <Button
            onClick={this.delBtnOnClicked}
            size="small"
            style={{ marginLeft: 10 }}
            className="negative-button"
          >
            Del
          </Button>

          <Divider type="vertical" />

          <Button
            onClick={this.operationRcdBtnOnClicked}
            size="small"
            style={{ marginLeft: 0 }}
            type="primary"
          >
            Operation Record
          </Button>
        </div>

        <div className="LicenseGrid"><LicenseGrid {...this.props} /></div>
        <AddOrEditLicenseModalDialog {...this.props} />
        <DelLicenseModalDialog {...this.props} />
        <OperationRecordDialog {...this.props} />
      </div>
    );
  }
}

export default LicenseDashboard;
